import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';
import {HttpService} from "../http.service";
import {NgForm} from "@angular/forms";
import {Response} from "@angular/http";

@Component({
  selector: 'app-contact-form-small',
  templateUrl: 'contact-form-small.component.html',
  styleUrls: ['contact-form-small.component.css']
})
export class ContactFormSmallComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.375;
  constructor(private service: GlobalServiceService, private httpService: HttpService) { }

  ngOnInit(){
    this.onResize();
    ContactFormSmallComponent.hidePopup();
  }

  onSubmit(form: NgForm) {
    let url = 'http://creativedigitalmailserver.us-west-2.elasticbeanstalk.com/mail?name=' + form.value.name.toString() + '&email='
     + form.value.email.toString() + '&phone=' + form.value.phone.toString() + '&budget=' + form.value.budget.toString();
    this.httpService.sendOrder(url).subscribe(
        data => ContactFormSmallComponent.processSuccess(data.status.toString()),
        err => ContactFormSmallComponent.processFail(err)
      );
  }

  static processSuccess(status: String) {
   ContactFormSmallComponent.showPopupSuccess();
  }

  static processFail(err) {
    ContactFormSmallComponent.showPopupFail();
  }

  onResize(){
    let width = $(window).width();
    let height = $(window).height();
    if (width > height) {
    this.height = this.service.getHeight(this.proportion);
    } else {
      this.height = this.service.getHeight(this.proportion) * 1.2;
    }
  }

  static showPopupSuccess() {
    $('.result').text('Congratulations!!!');
    $('.message').text('Your application has been successfully submitted. Your manager will contact you promptly');
    $('.send-message').css('display', 'block');
    $('.fader').css('display', 'block');
  }

  static showPopupFail() {
    $('.result').text('Ooops... We have faced an error!');
    $('.message').text('Try it again later or simply give us a call');
    $('.send-message').css('display', 'block');
    $('.fader').css('display', 'block');
  }

  static hidePopup() {
    $('.modal-content-close').click(function () {
      window.location.reload(false);
      $('.send-message').css('display', 'none');
      $('.fader').css('display', 'none');
    })
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/contact-form-small.component.ts